<script lang="ts">
  export let integrationName: string;
</script>

<div class="rounded-lg border border-dashed border-surface-400 bg-surface-50 p-6">
  <h3 class="mb-2 text-lg font-semibold">{integrationName} configuration</h3>
  <p class="text-sm text-gray-600">
    Config UI for <strong>{integrationName}</strong> is coming soon. Existing integration-specific tabs on this
    drawer will be migrated here in follow-up work.
  </p>
</div>
